import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import CONSTANTS from '../utils/constants';

export default function AdminLogin() {
    const [formData, setFormData] = useState({ phone: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(''); // Hata mesajları için ayrı bir state
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        if (!formData.phone || !formData.password) {
            setError('Telefon belgisi we açar sözüňiz gerek');
            setLoading(false);
            return;
        }

        const phoneRegex = /^\d{8}$/;
        if (!phoneRegex.test(formData.phone)) {
            setError('Telefon belgisi 8 san bolmaly');
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(`${CONSTANTS.baseRoute}/login`, {
                phone: `+993${formData.phone}`,
                password: formData.password,
            });

            setMessage(response.data.message);
            const userString = JSON.stringify(response.data.user);

            // Daha güvenilir bir çerez ayarı
            Cookies.set('user', userString, { expires: 7, path: '/', secure: true, sameSite: 'strict' });

            // localStorage yedeklemesi
            if (!Cookies.get('user')) {
                localStorage.setItem('user', userString);
            }

            setTimeout(() => navigate('/admin/home'), 1000); 
        } catch (err) {
            setError(err.response?.data?.error || 'Girişde ýalňyşlyk ýüze çykdy');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100" style={{ background: 'linear-gradient(to right, #f8f9fa, #e9ecef)' }}>
            <div className="card shadow-lg p-4 p-md-5" style={{ maxWidth: '450px', width: '100%', borderRadius: '15px' }}>
                <div className="text-center mb-4">
                    <img src="/logo.png" alt="Logo" style={{ width: '100px', height: 'auto' }} />
                    <h3 className="mt-3 fw-bold" style={{ color: '#333' }}>Täze aý</h3>
                </div>

                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="phone" className="form-label fw-semibold">Telefon belgisi</label>
                        <div className="input-group">
                            <span className="input-group-text bg-light border-end-0" style={{ color: '#EC6323' }}>+993</span>
                            <input
                                type="tel" // Daha doğru bir tip
                                className="form-control border-start-0"
                                id="phone"
                                placeholder="61234567"
                                value={formData.phone}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="mb-4">
                        <label htmlFor="password" className="form-label fw-semibold">Açar sözüňiz</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className="form-control"
                                id="password"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleInputChange}
                                required
                            />
                            <button type="button" className="btn btn-outline-secondary" onClick={togglePasswordVisibility}>
                                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                            </button>
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="btn btn-primary w-100 fw-bold d-flex align-items-center justify-content-center"
                        style={{ backgroundColor: '#EC6323', borderColor: '#EC6323', minHeight: '48px' }}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Ýüklenýär...
                            </>
                        ) : 'Giriş'}
                    </button>
                </form>
            </div>
        </div>
    );
}